// extracted by mini-css-extract-plugin
export default {"root":"RagFlow_root__0oiHq","main":"RagFlow_main__Rv95L"};